import { IonContent } from "@ionic/react";
import { connect } from "react-redux";
import { AppHeader } from "../../components/Header/AppHeader";
import UsersModule from "./components/UsersModule";

interface props {
	user: any;
}

const Users: React.FC<props> = ({ user }) => {
	return (
		<>
			<AppHeader title="Users" />
			<IonContent fullscreen className="ion-padding">
				<div className="container content-wrapper">
					{user.isAdmin && <UsersModule />}
					{!user.isAdmin && (
						<span>You do not have permission to view this page</span>
					)}
				</div>
			</IonContent>
		</>
	);
};

const mapPropsToState = (state: any) => ({
	user: state.user.userDetails,
});

export default connect(mapPropsToState, {})(Users);
